/* eslint-disable max-len */
import React, { useState } from 'react';
import { Dialogs, Dialog, Popup, Button, Flex, Text } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import SearchEditor from "../editor/SearchEditor.js";
import UserSettingsModelEditor from "../../../../views/userSettings/UserSettingsModelEditor.js";
import GroupedTextFilterModel from "../filter/GroupedTextFilterModel.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t,
  tIcon
} = I18N.ns('molten.screens.group.SearchSettings');
export default {
  id: 'molten.screens.group.search.SearchSettings',
  matches: {
    use: 'actionBar',
    client: 'molten.group.SearchBar'
  },
  handles: context => {
    return context?.clientProps?.searchModel?.TYPE === GroupedTextFilterModel.TYPE;
  },
  // appearance : ( { context, action } ) => {
  //   return { name : 'Edit Search Fields', icon : 'fa fa-fw fa-cog' }
  // },
  layout: {
    sort: 'zzzz'
  },
  customComponent: function SearchSettingsComponent({
    context
  }) {
    const {
      clientProps
    } = context;
    const {
      settingsPath,
      objectType
    } = clientProps;
    const [opened, setOpened] = useState(false);
    const openAdvanced = () => {
      setOpened(false);
      Dialogs.show({
        component: props => {
          const {
            show,
            onClose
          } = props;
          return /*#__PURE__*/_jsx(Dialog, {
            show: show,
            closeOnEscape: false,
            closeOnDocumentClick: false,
            onClose: onClose,
            children: /*#__PURE__*/_jsx(UserSettingsModelEditor, {
              ...props
            })
          });
        },
        props: {
          editor: SearchEditor,
          settingsPath,
          versionsPath: `${objectType}.freeTextSearch`,
          title: t('title'),
          modelName: t('modelName'),
          editorProps: {
            objectType
          }
        }
      });
    };
    return /*#__PURE__*/_jsx(Popup, {
      toggleVariant: "actionBar",
      opened: opened,
      onChange: ({
        isOpened
      }) => setOpened(isOpened),
      icon: tIcon('settingsIcon', 'fa fa-fw fa-gear'),
      children: /*#__PURE__*/_jsx(UserSettingsModelEditor, {
        simple: true,
        applyOnChange: true,
        closeOnSave: false,
        title: /*#__PURE__*/_jsxs(Flex, {
          align: "center",
          variant: "rowL",
          children: [/*#__PURE__*/_jsx(Text, {
            variant: "formTitle",
            children: t('title')
          }), /*#__PURE__*/_jsx(Button, {
            variant: "link",
            onClick: openAdvanced,
            children: t('advanced')
          })]
        }),
        onClose: () => setOpened(false),
        editor: SearchEditor,
        settingsPath: settingsPath,
        versionsPath: `${objectType}.freeTextSearch`,
        editorProps: {
          objectType
        }
      })
    });
  }
};